import React from 'react'
import { Typography, Card, Image } from 'antd'
import SimpleBackground from '@/components/SimpleBackground'

const { Title } = Typography

const UserInputScore = () => {
  return (
    <div className="m-auto h-full w-full">
      <SimpleBackground />
      <div className="m-auto w-[768px] max-w-full overflow-auto px-2 py-12 lg:px-6">
        <Image alt="" src="/manual/bg.png" preview={false} className="object-cover" />
        <Card bordered={false} className="w-full max-w-4xl bg-white shadow-lg lg:p-5">
          <Title className="text-center" level={1}>
            详解 9：成绩录入
          </Title>
          <div className="text-lg">
            <p>一、桌次上的菜单</p>
            <div className="my-4">
              <Image src="/manual/input_score/1.png" alt="" />
            </div>
            <p>1、每副牌结束后，点击进入，录入该桌本副牌成绩。</p>
            <div className="my-4">
              <Image src="/manual/input_score/2.png" alt="" />
            </div>
            <p>点击升级，选择获胜方和升级数，点确认，完成本副牌记分。</p>
            <div className="my-4">
              <Image src="/manual/input_score/3.png" alt="" />
            </div>
            <p>若记分出现错误，点撤销，每点一次，会从后往前撤销一笔记录。点击历史，可查看记分的详情。</p>
            <p>每轮比赛结束后，经双方核实无误，点击提交，锁定当前成绩，同时，提交按键会变为取消提交。若提交的成绩有误，点击取消提交，恢复到未提交状态。</p>
            <p>2、每轮牌结束后，如点击结算，对该桌成绩进行结算。结算功能同上。（但建议使用下文的一键结算功能）</p>
            <p>3、完成结算的桌次，结算按键自动变更为修改，点击修改，可对成绩进行修改。此处只修改本轮最终成绩，不修改中间记分过程。</p>
            <div className="my-4">
              <Image src="/manual/input_score/4.png" alt="" />
            </div>
            <p>二、一键结算</p>
            <p>点击操作→一键结算，对所有桌次的成绩进行结算。</p>
            <p>若选手提交成绩后未进行结算，或者迟迟不提交成绩，根据比赛要求和裁判长指令，为不影响比赛进程，可以进行强制结算，只有完成结算才能进行下一轮编排。</p>
            <p>三、对手分更新</p>
            <p>如果在赛事设置中把对手场分、对手级差分作为排名依据，一轮比赛结算后，如果修改了成绩，对手分不会同步更新。如果需要更新，必须再次点一键结算。</p>
            <p>需要注意的是，一键结算会把已生成编排的各轮次全部重新结算一遍，因此，必须要在生成新一轮编排前进行，否则新一轮的编排也会被结算。</p>
          </div>
        </Card>
      </div>
    </div>
  )
}

Object.assign(UserInputScore as any, {
  title: '成绩录入 · 灵缇赛事系统使用手册',
  description: '灵缇赛事系统成绩录入:每副牌录入获胜方与升级数、撤销与历史记录、每轮提交锁定成绩、扫码录分。',
})

export default UserInputScore
